import $ from "jquery";

$(document).on("input", "*[data-elem-to-enable]", function () {
  let field = $(this),
    target = field.data("elem-to-enable");
  $(`.${target}`).removeAttr("disabled");
});
